import { DatePipe } from '@angular/common';
import { Component, OnInit, Optional, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { BillingserviceService } from '../billingService.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, fromEvent, interval } from 'rxjs';
import { exhaustMap, map, startWith, take, takeUntil, tap } from 'rxjs/operators';
import { RequestBillDiscountDetail, ServiceList } from '../Models/billing.Models';
import { ReciptFormModel, RefundFormModel } from '../Models/billdetail.model';
import { MatDialog } from '@angular/material/dialog';
import { RefundComponent } from '../refund/refund.component';
import { SearchDialogComponent } from 'app/table-list/Searchdialog/SearchDialoag.component';
import * as moment from 'moment';
import { LanguageService } from 'app/shared/language.service';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { BranchMatserService } from 'app/masters/branch-matser.service';
import { FormControl } from "@angular/forms";
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
@Component({
  selector: 'app-advance-reciept',
  templateUrl: './advance-reciept.component.html',
  styleUrls: ['./advance-reciept.component.scss']
})
export class AdvanceRecieptComponent implements OnInit {

  todaysdate: any
  displayedColumns: string[] = ['serviceName', 'rate', 'qty', 'maxDiscountLimit', 'discount', 'serviceCharge', 'netAmount', 'serviceId'];
  dataSource = new MatTableDataSource<ServiceList>();
  // BillingData:BillingFormModel={};
  ReciptData: ReciptFormModel = {};
  RefundData: RefundFormModel = {};
  public masterconfigurationDiscount: any;
  //  patientid:number
  AllUserCtrl: FormControl;
  filteredAllUserArray: Observable<any[]>;
  walkin = true;
  withappointment = false;
  quantity = 1;
  totalpay: any;
  servicecharge: any;
  lessDiscount: any;
  netbillamount: any = 0;
  currentpayable: any;
  checktpa = 0;
  startdate: any;
  cuurentTime: any;
  BillDetailArray: any = [];
  checkService: any;
  partyAmount: any;
  copartyAmount: any;
  copartyId: any;
  public PartialAmount: any = 0;
  DipositeType: any = [];
  BnakType: any = [];
  PaymentType: any = [];
  ReciptArray: any = [];
  getreciptobj: any[];
  PatientId: number;
  BillID: number; t
  PartialBalancedAmmount: number = 0;
  dyanmiccheck: boolean = false;
  public AdjustedBillArray: any = [];
  public checkAdvancereciept: boolean = false;
  BillReciptAmount: number;
  private isviewmode = false;
  MinimeDate: any;
  reporturl: any;
  PageHeader: any;
  QrCode: any;
  showspinner = false;
  totalpadamountAgainstBill: number;
  checkpartialAdjust: boolean;
  public saveUsername: boolean;
  ChequeNoValidation: boolean = false;
  ChqBankIdValidation: boolean = false;
  rowClicked: any;
  cuurentDate: Date;
  show: boolean = true;
  childevent: boolean = true;
  bankdetailelvel1: any = "Card/Cheque No.";
  bankdetailelvel2: any = "Card/Cheque Date";

  requestDiscountAmount: RequestBillDiscountDetail = {};
  constructor(public authService: AuthService, public dialog: MatDialog, public ipdService: IPDService, public branchMatserService: BranchMatserService,
    public dashboardService: DashboardService,
    public opdvisitService: OpdVisitService, private datePipe: DatePipe,
    public router: Router, public translate: TranslateService,
    public dialogRef: MatDialogRef<AdvanceRecieptComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public billingservice: BillingserviceService, public langservice: LanguageService,) {
    //   setInterval(() => {this.cuurentTime =  new Date().toTimeString().split(" ")[0]}, 1);
    // console.log(this.billingservice.servicelist);
    this.translate.addLangs(['en', 'fr', 'hi', 'ar']);
    if (this.langservice.setlang) {
      this.translate.setDefaultLang(this.langservice.setlang);
      // this.selectedLanguage = this.langservice.setlang;
    }
    else {
      this.translate.setDefaultLang('en');
    }

  }
  disabledreceptbutton: boolean = false
  ngAfterViewInit(): void {

    fromEvent(this.button.nativeElement, 'click')
      .pipe(
        tap((x) => this.disabledreceptbutton = true),
        exhaustMap((ev) => {
          return this.createUser();
        })
      )
      .subscribe(this.handleResponse());
  }
  @ViewChild('recepitCreateBtn', { static: true }) button;
  clicks$: Observable<any>;
  createUser(): Observable<any> {
    return interval(500).pipe(take(1));

  }
  handleResponse(): any {
    return {
      next: (res) => {
        this.submitAdvanceRecipt()
      },
      error: (err) => {

      },

    };
  }

  ngOnInit() {

    this.childevent = true;
    this.AllUserCtrl = new FormControl();
    this.getdipaymenttype();
    this.getdiposittype();
    this.getbanktype();
    this.refereshRecieptData();
    var data = this.data;

    this.opdvisitService.patientdetails.pkRegId = data.patientId;
    this.ReciptData.FK_DepositTypeId = 1;
    // console.log('ttt',data);
    if (data.patientId) {
      this.get_recipt(data.patientId);
    }

    this.setreciptformdata(data);
    this.MinimeDate = moment(new Date()).format('YYYY-MM-DD');
    this.getproductmasterconfig();
    this.billingservice.AdjustedBillingAmount = 0;
    this.checkpartialAdjust = false;
    this.opdvisitService.patiendFullNameForReciept = '';
    //  this.PageHeader.propertyValue = 'Y';
    this.getBranchDetail(this.authService.Loggeduser.branchid);

    this.dashboardService.moudletype
      .subscribe((quote) => {
        if (quote == 1) {
          this.getdoctorlist();
        }
      });

    this.AllUserControll();
    this.ReciptData.FK_BillingCompanyId = this.authService.Loggeduser.billingcompanyid;
    this.rowClicked = -1;
  }


  changeTableRowColor(receiptdata: any, idx: any) {

    if (this.rowClicked === idx) {
      this.rowClicked = -1;
      this.disabledreceptbutton = false;
      this.isviewmode = false;
      this.setadvancerecieptdata();
    } else {
      this.isviewmode = true;
      this.disabledreceptbutton = true;
      this.rowClicked = idx;
      this.setreciptdata(receiptdata);
    }


  }

  getproductmasterconfig() {
    let BranchId = this.authService.Loggeduser.branchid;
    this.dashboardService.subscriptions = this.billingservice.getproductionConfrigration(BranchId).subscribe(data => {
      // console.log('master confrigartion',data);
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        if (element?.propertyName === "DiscountonBill") {
          this.masterconfigurationDiscount = element;
        }

        if (element?.propertyName === "PageHeadWebReport") {
          this.PageHeader = element;
        } if (element.propertyName === "WebURL") {
          this.reporturl = element.propertyValue;
        }
        if (element?.propertyName === "Patientsticker_barcode") {
          this.QrCode = element;
        }
        // else{
        //   this.QrCode.propertyValue = 'N';
        // }


        // public PageHeader:any ={};
        // public :any={};
      }
    })
  }

  refereshRecieptData() {
    this.checkAdvancereciept = false;
    this.ReciptData.IsAdjusted = false;
    this.billingservice.savebilldetail.rateTypeId = 0;
    this.opdvisitService.patientdetails = {};
    this.opdvisitService.activevisit = 0;
    this.AdjustedBillArray = null;
    this.ReciptData = {};
    this.PartialAmount = 0;
    this.DipositeType = [];
    this.BnakType = [];
    this.PaymentType = [];
    this.ReciptArray = [];
    this.getreciptobj = [];
    this.PatientId = null;
    this.BillID = null;
    this.billingservice.billserviceConfig = null;
    this.PartialBalancedAmmount = 0;
    this.dyanmiccheck = false;
    this.AdjustedBillArray = [];
    this.billingservice.lastbillid = null;
    this.BillReciptAmount = 0;
    this.opdvisitService.PatientisExpire = null;
    this.ReciptData.IsCoPayment = false;
    this.ReciptData.Createdby = this.authService.Loggeduser.pUserName;
  }

  get_recipt(p: number) {
    this.showspinner = true;
    this.dashboardService.subscriptions = this.billingservice.getAdvanceReciept(p).subscribe(data => {
      this.showspinner = false;
      if (data.length > 0) {
        this.ReciptArray = data.map(item => ({
          ...item,
          isEdittbn: false
        }));
      }
      for (let index = 0; index < this.ReciptArray.length; index++) {

        this.ReciptArray[index].netAmt = this.ReciptArray[index].balanceAmount
        // this.AdjustedBillArray = [];
        // this.dashboardService.subscriptions = this.billingservice.getAdustedDetails(this.ReciptArray[index]?.pK_ReceiptId, 0).subscribe(data => {
        //   this.AdjustedBillArray = data;
        //   var Amount = 0;
        //   var recoverycalculate = 0;
        //   if (data.statusCode) {
        //     this.ReciptArray[index].netAmt = this.ReciptArray[index].netAmt - (this.ReciptArray[index].refunded + this.ReciptArray[index].billRefund);

        //   }
        //   if (this.AdjustedBillArray.length > 0) {
        //     this.AdjustedBillArray?.forEach(element => {
        //       Amount = Amount + element.adjustedAmount;
        //       recoverycalculate = recoverycalculate + (element.amountTDS + element.amountDiscount + element.amountDisAllow + element.amountST)
        //     });
        //     if (this.ReciptArray != null) {
        //       this.ReciptArray[index].netAmt = (this.ReciptArray[index].netAmt + recoverycalculate) - (Amount + this.ReciptArray[index]?.refunded + this.ReciptArray[index]?.billRefund);

        //     }



        //   }
        // });

      }

    }, err => {
      this.showspinner = false;
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }

    })
  }
  // updateadjustedAmount(e:number,obj:any){
  //   this.checkpartialAdjust = false;
  //   document.getElementById("PartialAmountModel").style.display = "none";
  //   obj.adjustedAmount =e;
  // console.log('amount',e,'object',obj);
  // this.billingservice.addPartialAmount(obj).subscribe(data=>
  //   this.success_partialAmount(data),err=> this.failed_partialAmount(err)
  //   )
  // }
  getfinyearstring(finyearid: number) {
    return this.authService.FinYears.find(fy => fy.pkFinYearId == finyearid).displayFinYear;
  }
  // get doctor list 

  // get doctor list 
  getdoctorlist() {
    this.opdvisitService.doctors = [];
    this.dashboardService.subscriptions = this.dashboardService.getall_doctors().
      subscribe(data => this.success_doctors(data), err => this.failed_doctors(err));
  }

  success_doctors(data) {
    if (this.authService.masterdata.isExternal === true) {
      this.opdvisitService.doctors = data.filter(item => item.isExternal == false);

    }
    else {
      this.opdvisitService.doctors = data;

    }



  }
  failed_doctors(err) {

  }
  //config billing module

  closedialog() {
    this.dialogRef.close();
  }

  getConfiglist() {
    this.billingservice.billserviceConfig = {};
    let BranchId = this.authService.Loggeduser.branchid;
    //  let BranchId=1;
    this.dashboardService.subscriptions = this.billingservice.get_Bill_Congigrationlist(BranchId).
      subscribe(data => this.success_config(data), err => this.failed_config(err));
  }
  success_config(data) {
    // debugger
    this.billingservice.billserviceConfig = data[0];
    this.getRateList(this.billingservice.billserviceConfig.fK_PartyId);
    this.ReciptData.FK_DoctorId = this.billingservice.billserviceConfig.fK_DoctorId;
    this.ReciptData.FK_PartyId = this.billingservice.billserviceConfig.fK_PartyId;

  }

  failed_config(err) {
    this.billingservice.billserviceConfig.fK_BillSerieseId = 0;
    this.billingservice.billserviceConfig.fK_BillTypeId = 0;
    this.billingservice.billserviceConfig.fK_CategoryId = 0;
    this.billingservice.billserviceConfig.fK_DoctorId = 0;
    this.billingservice.billserviceConfig.fK_ReferredById = 0;
    this.billingservice.billserviceConfig.fK_PartyId = 0;
    this.billingservice.billserviceConfig.fK_RatelistId = 0;

    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  // get Bill service 
  getBillservice() {
    this.dashboardService.subscriptions = this.billingservice.get_BillService().subscribe(data => this.success_bill(data), err => this.failed_billservice(err));
  }
  success_bill(data) {
    this.billingservice.billService = data;
  }
  failed_billservice(err) {

  }
  //get party tpa
  getPartTpa() {
    this.dashboardService.subscriptions = this.billingservice.get_partytpa().subscribe(data => this.success_partytpa(data), err => this.failed_partytpa(err));
  }
  success_partytpa(data) {
    this.billingservice.partytpa = data;
    this.copartyId = this.billingservice.partytpa[1].pkPartyId;
    // console.log('partyNme',this.billingservice.partytpa);
  }
  failed_partytpa(err) {

  }


  openModalDialog(data) {
    document.getElementById("recipModel").style.display = "block";
    // this.setreciptdata(data);
  }

  closeModalDialog() {
    // this.display='';
    document.getElementById("recipModel").style.display = "none";
    this.ReciptData = {};
    // this.BillingData = {};

  }
  // get rate typelist

  GetRateType() {
    this.dashboardService.subscriptions = this.billingservice.get_rate_typelist().subscribe((data: any[]) => {

      this.billingservice.ratetype = data;
      // console.log('billingservice.ratetype',data)
    })
  }

  GetBillType() {
    this.dashboardService.subscriptions = this.billingservice.get_typelist().subscribe((data: any[]) => {
      this.billingservice.billtype = data;
    })
  }
  //get rate list 
  getRateList(event) {
    if (event != 0) {
      let BranchId = this.authService.Loggeduser.branchid;
      let PartyId = event;
      this.dashboardService.subscriptions = this.billingservice.get_rate_list(BranchId, PartyId).subscribe((data: any[]) => {

        this.billingservice.ratelist = data[0];
        if (data.length > 0) {
          this.checktpa = 1;
        }
        // this.billingservice.ratelist[0].rateListId
      })
    } else {
      this.billingservice.ratelist.rateList = '';
      this.checktpa = 0;
    }
  }


  // setbillingformdata(){
  //   this.ngOnInit();
  //   // this.setbiilingdata();
  //   }



  opensearchD(): void {
    // this.refreshdata();       
    // this.showspinner =true;    
    // this.opdvisitService.get_top_200_patients().subscribe(
    //   data => this.success_top_200_patients(data),
    // );
    const dialogRef = this.dialog.open(SearchDialogComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "80%",
      width: "90%"
    });

    this.dashboardService.subscriptions = dialogRef.afterClosed().subscribe(result => {
      if (this.opdvisitService.patientdetails?.pkRegId > 0) {
        this.getpid(this.opdvisitService.patientdetails?.pkRegId);
        this.get_recipt(this.opdvisitService.patientdetails?.pkRegId);

      } else {
        // this.refreshdata();
        this.opdvisitService.patiendFullNameForReciept = '';
      }
    });
  }
  cleardata(event: any) {
    if (!event.target.value) {
      this.refreshdata();
    }
  }
  // success_top_200_patients(data) {
  //   this.opdvisitService.checkshort = true;
  //   this.showspinner =false;
  //   this.opdvisitService.patients = data;
  //   const dialogRef = this.dialog.open(SearchDialogComponent, {
  //     panelClass: "full-width-dialog",
  //     maxWidth: "100vw !important",
  //     height: "80%",
  //     width: "90%"
  //   });

  //   dialogRef.afterClosed().subscribe(result => {

  //     if(result >0){
  //       this.getpid(event,result);
  //       this.get_recipt(result);

  //     }else{
  //       // this.refreshdata();
  //       this.opdvisitService.patiendFullNameForReciept = '';
  //     }
  //   });
  // }




  setreciptformdata(a: any) {
    this.cuurentTime = new Date().toTimeString().split(" ")[0];
    this.opdvisitService.getpersonmaster('BILLING', 0);
    this.getdoctorlist();
    this.getBillservice();
    this.getPartTpa();
    this.GetRateType();
    this.GetBillType();
    this.getConfiglist();
    this.getdiposittype();
    this.getdipaymenttype();
    this.getdipaymenttype();
    this.getdiposittype();
    this.getbanktype();
    this.AdjustedBillArray = [];
    var data = a.recipobj;


    if (a.pid > 0 && a.billId > 0) {
      this.PatientId = a.pid;
      this.BillID = a.billId;

      this.billingservice.lastbillid = a.billId;

      this.BillReciptAmount = data.CurrencyAmount;
      this.ReciptData.PaymentTime = this.cuurentTime;
      this.opdvisitService.patientdetails.pkRegId = this.PatientId;
      this.get_recipt(this.PatientId);

      if (a.checkAmount === true) {
        this.ReciptData.CurrencyAmount = 0
      } else {
        this.ReciptData.CurrencyAmount = data.CurrencyAmount
      }
      this.ReciptData.PK_ReceiptId = data.PK_ReceiptId,
        this.ReciptData.ReceiptNo = data.ReceiptNo,
        this.ReciptData.FK_RegId = data.FK_RegId,
        this.ReciptData.FK_CreatedById = data.FK_CreatedById,
        this.ReciptData.FK_CancelledById = data.FK_CancelledById,
        this.ReciptData.PrintCount = data.PrintCount,
        this.ReciptData.IsActive = data.IsActive,
        this.ReciptData.FK_BillingCompanyId = data.FK_BillingCompanyId,
        this.ReciptData.FK_FinyearId = data.FK_FinyearId,
        this.ReciptData.FK_BranchId = data.FK_BranchId,
        this.ReciptData.PaymentDate = data.PaymentDate,
        this.ReciptData.FK_DoctorId = data.FK_DoctorId
      this.ReciptData.FK_DepositHeadId = data.FK_DepositHeadId,
        this.ReciptData.FK_CurrencyId = data.FK_CurrencyId,
        this.ReciptData.FK_DepositTypeId = data.FK_DepositTypeId,
        this.ReciptData.ConvertRetio = data.ConvertRetio,
        this.ReciptData.AmountINR = data.AmountINR,
        this.ReciptData.AmountTDS = data.AmountTDS,
        this.ReciptData.AmountDiscount = data.AmountDiscount,
        this.ReciptData.AmountDisAllow = data.AmountDisAllow,
        this.ReciptData.AmountST = data.AmountST,
        this.ReciptData.FK_PayTypeId = data.FK_PayTypeId,
        this.ReciptData.ChequeNo = null,
        this.ReciptData.CardType = data.cardType ? data.cardType : null,
        this.ReciptData.ChequeDate = moment(this.ReciptData.ChequeDate).format('YYYY-MM-DD')
      // console.log(this.ReciptData.ChequeDate);
      this.ReciptData.FK_ChqBankId = data.FK_ChqBankId,
        this.ReciptData.RefBankBranch = data.RefBankBranch,
        this.ReciptData.FK_ClrBankId = data.FK_ClrBankId,
        // this.ReciptData.IsCoPayment =false;
        this.ReciptData.IsCoPayment = data.IsCoPayment,
        this.ReciptData.IsAdjusted = data.IsAdjusted,
        this.ReciptData.FK_AdjustedBillId = data.FK_AdjustedBillId,
        this.ReciptData.UserRemarks = data.UserRemarks,
        this.ReciptData.Iscancelled = data.Iscancelled,
        this.ReciptData.RecptGenerateBSWise = data.RecptGenerateBSWise;
    }
    else {
      this.checkAdvancereciept = true;
      this.ReciptData.FK_DepositHeadId = 1;
      this.ReciptData.FK_PayTypeId = 1;
      //  this.setAdvanceRecipt();
    }


  }

  setreciptdata(data: any) {
    this.ReciptData = {};
    this.cuurentTime = new Date().toTimeString().split(" ")[0];
    //  console.log(data, )
    //  if(this.BillID >0){
    //   this.ReciptData.FK_AdjustedBillId = this.BillID;
    // }
    // else{
    this.ReciptData.FK_AdjustedBillId = data.fK_AdjustedBillId;
    // }
    this.ReciptData.receiptNoFull = data.receiptNoFull,
      this.ReciptData.PK_ReceiptId = data.pK_ReceiptId,
      this.ReciptData.ReceiptNo = data.receiptNo,
      this.ReciptData.FK_RegId = data.fK_RegId,
      this.ReciptData.FK_DoctorId = data.fK_DoctorId,
      this.ReciptData.FK_CreatedById = this.authService.Loggeduser.userid,
      this.ReciptData.FK_CancelledById = data.fk_CancelledById,
      this.ReciptData.PrintCount = data.printCount,
      this.ReciptData.FK_PartyId = data.fK_PartyId,
      this.ReciptData.IsActive = data.isActive,
      this.ReciptData.FK_BillingCompanyId = data.fK_BillingCompanyId,
      this.ReciptData.FK_FinyearId = data.fK_FinyearId,
      this.ReciptData.FK_BranchId = data.fK_BranchId,
      this.ReciptData.PaymentDate = data.PaymentDate,
      this.ReciptData.PaymentTime = data.paymentTime
    //  toTimeString().split(" ")[0]
    this.ReciptData.PaymentDate = data.payDate,
      this.ReciptData.FK_CancelledById = data.fK_CancelledById,
      this.ReciptData.FK_DepositHeadId = parseInt(data.fK_DepositHeadId),
      this.ReciptData.FK_CurrencyId = data.fK_CurrencyId,
      this.ReciptData.CurrencyAmount = data.currencyAmount,
      this.ReciptData.ConvertRetio = data.convertRetio,
      this.ReciptData.AmountINR = data.amount,
      this.ReciptData.AmountTDS = data.amountTDS,
      this.ReciptData.AmountDiscount = data.amountDiscount,
      this.ReciptData.AmountDisAllow = data.amountDisAllow,
      this.ReciptData.AmountST = data.amountST,
      this.ReciptData.FK_PayTypeId = data.fK_PayTypeId,
      this.ReciptData.ChequeNo = data.chequeNo,
      // this.ReciptData.ChequeDate  =this.datePipe.transform(data.ChequeDate,"dd-MM-YYYY"),
      this.ReciptData.ChequeDate = moment(this.ReciptData.ChequeDate).format('YYYY-MM-DD')

    this.ReciptData.FK_ChqBankId = data.fK_ChqBankId,
      this.ReciptData.RefBankBranch = data.refBankBranch,
      this.ReciptData.FK_ClrBankId = data.fK_ClrBankId,
      this.ReciptData.FK_DepositTypeId = parseInt(data.fK_DepositTypeId),
      this.ReciptData.IsCoPayment = data.isCoPayment,
      this.ReciptData.IsAdjusted = data.isAdjusted;
    this.ReciptData.CardType = data.cardType;
    this.ReciptData.Createdby = data.createdBy;
    this.ReciptData.AdjustedAmount = data.adjustedAmount ? data.adjustedAmount : 0;
    this.ReciptData.AdRefound = data.refunded ? data.refunded : 0;
    // if(data.isAdjusted ==0){
    //   this.ReciptData.IsAdjusted= this.BillID;
    // }
    // this.ReciptData.FK_ChqBankId =data.FK_ChqBankId


    this.ReciptData.UserRemarks = data.userRemarks,
      this.ReciptData.Iscancelled = data.iscancelled
    this.ReciptData.RecptGenerateBSWise = ""

    // console.log('set recipt obj',this.ReciptData)

  }

  // }


  getdiposittype() {
    this.billingservice.getdepositeType().subscribe(data => {
      // console.log('billpaytype',data);
      this.DipositeType = data;
    })
  }

  getdipaymenttype() {
    this.billingservice.getpaymentType().subscribe(data => {
      // console.log(data);
      this.PaymentType = data;
    })
  }

  getbanktype() {
    this.billingservice.getbankType().subscribe(data => {
      // console.log(data);
      this.BnakType = data;
    })
  }
  checkenable($event) {
    if (this.dyanmiccheck == true && !this.isviewmode) {
      this.disabledreceptbutton = false;
    }
  }
  chnagePaymentMode(e) {
    var value = e;
    if (value == 1 || value == 2 || value == 3) {
      this.dyanmiccheck = value == 1 ? false : true;
      this.bankdetailelvel1 = "Card/Cheque No.";
      this.bankdetailelvel2 = "Card/Cheque Date";
      this.ReciptData.ChequeNo = null;
      this.ReciptData.CardType = null;
      this.ReciptData.ChequeDate = this.authService.getServerDate;
      this.ReciptData.FK_ChqBankId = null;
      this.ReciptData.RefBankBranch = null;
      this.ReciptData.FK_ClrBankId = null;
      this.show = true;
      if (value == 1) {
        this.ChequeNoValidation = false
        this.ChqBankIdValidation = false;
      }
    } else {
      this.dyanmiccheck = true;
      this.bankdetailelvel1 = "Transaction No.";
      this.bankdetailelvel2 = "Transaction Date";
      this.ReciptData.ChequeNo = null;
      this.ReciptData.CardType = null;
      this.ReciptData.ChequeDate = this.authService.getServerDate;
      this.ReciptData.FK_ChqBankId = null;
      this.ReciptData.RefBankBranch = null;
      this.ReciptData.FK_ClrBankId = null;
      if (value == 7) {
        this.show = false;
      } else {
        this.show = true;
      }
    }
  }

  public onSaveUsernameChanged(value: boolean) {
    this.saveUsername = value;
    this.ReciptData.IsCoPayment = value
  }
  uhidValidation: boolean = false;
  AmountValidation: boolean = false;
  DoctorValidation: boolean = false;
  PartyValidation: boolean = false;
  @ViewChild('uhidref', { static: false }) private UHIDref: ElementRef;
  @ViewChild('ammountref', { static: false }) private AmmountRef: ElementRef;

  submitAdvanceRecipt() {

    if (this.opdvisitService.patientdetails.pkRegId != null) {
      this.ReciptData.AgeYear = this.opdvisitService.patientdetails.ageYear;
      this.ReciptData.AgeMonth = this.opdvisitService.patientdetails.ageMonth;
      this.ReciptData.AgeDays = this.opdvisitService.patientdetails.ageDays;
      if (this.ReciptData.CurrencyAmount > 0) {
        const camount = this.ReciptData.CurrencyAmount;
        const A_amount = this.ReciptData.AdjustedAmount ? this.ReciptData.AdjustedAmount : 0;
        const A_refund = this.ReciptData.AdRefound ? this.ReciptData.AdRefound : 0;
        if (Number(A_amount) + Number(A_refund) > Number(camount)) {
          this.disabledreceptbutton = false;
          this.dashboardService.openSnackBar("Please enter valid Amount ", "OK");
          return
        }

        if (this.ReciptData.FK_DoctorId != null || this.ReciptData.FK_DoctorId != undefined) {

          if (this.ReciptData.FK_PartyId) {
            this.cuurentTime = new Date().toTimeString().split(" ")[0];
            this.RefundData.FK_BranchId = this.authService.Loggeduser.branchid;
            if (this.opdvisitService.patientdetails.isExpired === true) {
              this.disabledreceptbutton = false;
              this.dashboardService.openSnackBar("This Patient is Expired  ", "OK");
            }
            else {
              this.ReciptData.FK_DepositHeadId = parseInt(this.ReciptData.FK_DepositHeadId)
              this.ReciptData.FK_PayTypeId = parseInt(this.ReciptData.FK_PayTypeId);
              if (this.ReciptData.FK_AdjustedBillId > 0) {
                this.ReciptData.IsAdjusted = this.ReciptData.IsAdjusted;

              }
              else {
                this.ReciptData.IsAdjusted = 0;
              }
              if (this.billApprovalobject.length > 0) {
                this.ReciptData.PK_TranID_Approval = this.billApprovalobject[0]?.pK_TranID;
                this.ReciptData.RequestUsed = 1;
              }
              this.ReciptData.FK_DepositTypeId = this.ReciptData.FK_DepositTypeId;
              this.ReciptData.CurrencyAmount = parseInt(this.ReciptData.CurrencyAmount);
              this.ReciptData.AmountINR = parseInt(this.ReciptData.AmountINR);

              this.ReciptData.PaymentTime = new Date().toTimeString().split(" ")[0]
              this.ReciptData.AmountINR = this.ReciptData.CurrencyAmount;
              if (this.ReciptData.FK_AdjustedBillId === null || this.ReciptData.FK_AdjustedBillId === ' ' ||
                this.ReciptData.FK_AdjustedBillId === undefined) {
                this.disabledreceptbutton = false;
                this.dashboardService.openSnackBar("Please check all mandatory fields", "OK");
                return;
              }

              if ((this.BillReciptAmount < this.ReciptData.CurrencyAmount) && this.ReciptData.FK_AdjustedBillId > 0) {
                this.disabledreceptbutton = false;
                this.dashboardService.openSnackBar("Receipt Amount can't be greater than bill Amount", "OK");
                return;
              }
              else {
                this.ReciptData.CurrencyAmount = parseInt(this.ReciptData.CurrencyAmount);


                if (this.ReciptData.FK_PayTypeId === 2 || this.ReciptData.FK_PayTypeId === 3 || this.ReciptData.FK_PayTypeId === 6) {
                  if (this.ReciptData.ChequeNo && (this.ReciptData.FK_ChqBankId || this.show == false)) {
                    this.ReciptData.FK_ChqBankId = parseInt(this.ReciptData.FK_ChqBankId);
                    this.ReciptData.ChequeNo = this.ReciptData.ChequeNo;
                    this.ReciptData.ChequeDate = this.ReciptData.ChequeDate;
                    this.dyanmiccheck = false;
                    this.ReciptData.PaymentDate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
                    this.showspinner = true;
                    this.ReciptData.IsEdit = this.ReciptData.PK_ReceiptId > 0 ? true : false;
                    this.ReciptData.ReqType = 'R';
                    this.dashboardService.subscriptions = this.billingservice.addrecipts(this.ReciptData).
                      subscribe(data => this.recipt_Succsess(data), err => this.recipt_failed(err));

                  }
                  else {

                    this.ChequeNoValidation = true
                    this.ChqBankIdValidation = true;
                    this.dashboardService.openSnackBar("Please check all mandatory fields ", "ok");
                    this.showspinner = false;
                    return;
                  }

                }
                else {

                  this.dyanmiccheck = false;
                  // console.log('recept',this.ReciptData)
                  this.ReciptData.PaymentDate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
                  this.showspinner = true;
                  this.ReciptData.IsEdit = this.ReciptData.PK_ReceiptId > 0 ? true : false;
                  this.ReciptData.ReqType = 'R';
                  this.dashboardService.subscriptions = this.billingservice.addrecipts(this.ReciptData).
                    subscribe(data => this.recipt_Succsess(data), err => this.recipt_failed(err));

                }
              }
            }
          } else {
            this.dashboardService.openSnackBar("Please select party name", "OK");
            this.PartyValidation = true;
          }
        } else {
          this.dashboardService.openSnackBar("Please select doctor name", "OK");
          this.DoctorValidation = true
        }
      }
      else {
        this.dashboardService.openSnackBar("Received Amount will be greater than zero ", "ok");
        this.AmountValidation = true;
        setTimeout(() => {
          this.AmmountRef.nativeElement.focus();
        }, 100);
      }
    } else {
      this.dashboardService.openSnackBar("Please Enter UHID", "OK");
      this.uhidValidation = true;
      setTimeout(() => {
        this.UHIDref.nativeElement.focus();
      }, 100);
    }
    this.disabledreceptbutton = false;
  }

  getpid(regid?: number): void {

    if (regid > 0) {
      this.childevent = false;
      this.PatientId = regid;
      this.dashboardService.subscriptions = this.opdvisitService.getpatientdetailsforReciept(this.PatientId).subscribe(data => this.patient_succsess(data), err => this.patient_failed(err));
    } else {
      this.opdvisitService.patiendFullNameForReciept = '';


      this.refreshdata();

    }

  }
  // getpatiendId
  patient_succsess(data) {
    if (data.pkRegId != null) {

      this.opdvisitService.patientdetails.pkRegId = data.pkRegId;
      this.opdvisitService.patientdetails.isExpired = data.isExpired;
      this.opdvisitService.patiendFullNameForReciept = data.firstName + ' ' + data.lastName;
      if (data.dob != null) {
        this.opdvisitService.patientdetails.dob = this.datePipe.transform(data.dob, "yyyy-MM-dd");
        this.opdvisitService.getages(data.dob);
      } else {
        var tdate = new Date(data.regDate);
        this.opdvisitService.patientdetails.ageYear = this.opdvisitService.patientdetails.ageYear != null ? this.opdvisitService.patientdetails.ageYear : 0;
        this.opdvisitService.patientdetails.ageMonth = this.opdvisitService.patientdetails.ageMonth != null ? this.opdvisitService.patientdetails.ageMonth : 0;
        this.opdvisitService.patientdetails.ageDays = this.opdvisitService.patientdetails.ageDays != null ? this.opdvisitService.patientdetails.ageDays : 0;
        tdate.setDate(tdate.getUTCDate() - this.opdvisitService.patientdetails.ageDays);
        tdate.setMonth(tdate.getMonth() - this.opdvisitService.patientdetails.ageMonth);
        tdate.setFullYear(tdate.getFullYear() - this.opdvisitService.patientdetails.ageYear);
        this.opdvisitService.patientdetails.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");
        this.opdvisitService.getDataDiffs(new Date(this.opdvisitService.patientdetails.dob), new Date(this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd")));
      }
      this.get_recipt(this.PatientId);

      this.setadvancerecieptdata();
      if (this.opdvisitService.patientdetails.isExpired === true) {
        this.dashboardService.openSnackBar("This Patient is Expired  ", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("This Patient is Not Registered  ", "OK");
      this.refreshdata();

    }
    // this.patientdetails.pkRegId = data.pkRegId;
    // this.PatientisExpire = data.isExpired;
    // this.checkpatient = data.pkRegId;
    //  this.patiendFullNameForReciept = data.firstName+' '+data.lastName;
  }

  patient_failed(err) {

    this.showspinner = false;
    this.dashboardService.openSnackBar("Patient Not found", "OK");
    this.opdvisitService.patientdetails.pkRegId = null;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  // subscribe(data=>{

  // });

  setadvancerecieptdata() {
    this.setAdvanceRecipt();
    this.ReciptData.CurrencyAmount = 0;
    //  this.AdjustedBillArray = [];

  }
  // getpatiendId(id:number){
  //   console.log('pid',id);
  //   this.ReciptData.FK_RegId =id;

  //    this.opdvisitService.patientdetails.pkRegId= id;

  //    } 

  recipt_Succsess(data) {
    this.showspinner = false;
    this.uhidValidation = false;
    this.AmountValidation = false;
    this.DoctorValidation = false;
    this.PartyValidation = false;
    this.ChequeNoValidation = false;
    this.ChqBankIdValidation = false;

    if (this.ReciptData.PK_ReceiptId > 0) {
      this.dashboardService.openSnackBar("Receipt Updated Succsessfully", "OK");
    }
    else {
      this.dashboardService.openSnackBar("Receipt Created Succsessfully", "OK");
    }

    this.setAdvanceRecipt();
    if (this.BillID == 0) {
      this.get_recipt(this.PatientId);
    }
    else {
      this.get_recipt(this.PatientId);
    }

    this.setrefundformdata();
    this.ReciptData.CurrencyAmount = 0;
    //  this.ReciptData.CurrencyAmount =0;
    this.disabledreceptbutton = false;
  }
  recipt_failed(err) {
    this.showspinner = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }


  openRefunddailog(id: number, a: number, nun: any, refundtype: any, netamount: any) {
    // console.log('reciptid',id)
    const dialogRef = this.dialog.open(RefundComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "90%",
      width: "70%",
      data: { recieptId: id, Amount: a, no: nun, ReciptDataobj: this.ReciptData, refundType: refundtype, netAmount: netamount }
    });

    this.dashboardService.subscriptions = dialogRef.afterClosed().subscribe(result => {

      this.get_recipt(this.PatientId);

    })
  }


  // refund Section 
  setrefundformdata() {
    this.cuurentTime = new Date().toTimeString().split(" ")[0];
    this.RefundData.FK_BranchId = this.authService.Loggeduser.branchid;
    this.RefundData.RefundType = 'B';
    this.RefundData.RefundDate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    this.RefundData.RefundTime = this.cuurentTime;
    this.RefundData.FK_ApprovedById = this.authService.Loggeduser.userid;
    this.RefundData.RefundReason = null;
    this.RefundData.FK_PayTypeId = this.ReciptData.FK_PayTypeId;
    this.RefundData.FK_CurrencyId = 1;
    this.RefundData.CurrencyAmount = this.ReciptData.CurrencyAmount;
    this.RefundData.ConvertRetio = 1;
    this.RefundData.RefundAmount = this.ReciptData.CurrencyAmount;
    this.RefundData.ChequeNo = null;
    this.RefundData.ChequeDate = null;
    this.RefundData.FK_ChqBankId = null;
    this.RefundData.FK_CreatedById = this.authService.Loggeduser.userid;
    this.RefundData.IsActive = 1;
    this.RefundData.PK_RefundId = 0;


  }

  billApprovalobject: any = [];
  // editpaymentMode() {
  //  this.disabledreceptbutton = false;
  //  this.ReciptData.IsAdjusted =true;
  // }
  getadjustedbills(reciept: any, i: number, etype: any) {

    this.editbillingform(reciept, 'ReceiptModification', i, etype)

  }
  popupdynamicData: string = '';
  editbillingform(receiptdata: any, type: any, i: number, etype: any) {
    this.isviewmode = false;
    this.disabledreceptbutton = false;
    if (this.billingservice.billserviceConfig.approvalSystem) {

      const { branchid } = this.authService.Loggeduser;
      const serverDate = this.authService.getServerDate;
      this.requestDiscountAmount.FK_BillID = receiptdata.pK_ReceiptId;
      this.dashboardService.subscriptions = this.billingservice
        .getRequestStatusdata(branchid, serverDate, serverDate, type, 0, receiptdata.pK_ReceiptId)
        .subscribe(
          (response: any) => {
            if (response.length === 0) {
              this.rowClicked = -1;
              this.setadvancerecieptdata();
              this.approvalmodel();
              return;
            }

            const pendingList = response.filter(item => item.status === "Pending");
            const rejectedList = response.filter(item => item.status === "Reject");
            const approvedUnusedList = response.filter(
              item => item.status === "Approved" && item.requestUsed == null
            );

            const messagePrefix = type === "ReceiptModification"
              ? "Receipt Modification"
              : "Receipt Modification";

            const showPopup = (message: string) => {
              this.popupdynamicData = `${messagePrefix} ${message}`;
              document.getElementById("billModificationRequestpending").style.display = "block";
            };

            if (pendingList.length > 0) {
              showPopup("Pending for Approval.");
            } else if (rejectedList.length > 0 && approvedUnusedList.length === 0) {
              showPopup("Request is Rejected.");
            } else if (approvedUnusedList.length > 0) {
              this.billApprovalobject = approvedUnusedList;
              this.ReciptArray = this.ReciptArray.map((item, index) => ({
                ...item,
                isEdittbn: index === i ? etype : false
              }));
              if (etype == true) {
                if (receiptdata.payType.toLowerCase() != 'cash') {
                  this.dyanmiccheck = true;
                }
                this.setreciptdata(receiptdata);

              } else {
                this.dyanmiccheck = false;
                this.setadvancerecieptdata();
              }
              //  this.changeTableRowColor(i);
            } else {
              this.rowClicked = -1;
              this.setadvancerecieptdata();
              this.approvalmodel();

            }
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    } else {
      this.ReciptArray = this.ReciptArray.map((item, index) => ({
        ...item,
        isEdittbn: index === i ? etype : false
      }));
      if (etype == true) {
        if (receiptdata.payType.toLowerCase() != 'cash') {
          this.dyanmiccheck = true;
        }
        this.setreciptdata(receiptdata);
      } else {
        this.dyanmiccheck = false;
        this.setadvancerecieptdata();
      }

      // this.changeTableRowColor(i);
    }

  }
  SendForDiscountApproval(event: any, type: string) {
    const button =
      event?.srcElement?.disabled === undefined
        ? event.srcElement?.parentElement
        : event.srcElement;

    button?.setAttribute("disabled", true);

    const approvalById = this.requestDiscountAmount.FK_ApprovedByID;

    if (!approvalById || approvalById === 0) {
      return this.dashboardService.openSnackBar("Please Select Approval By", "ok");
    }

    if (!this.requestDiscountAmount.Reason) {
      return this.dashboardService.openSnackBar("Please Enter Reason", "ok");
    }

    const currentUserId = this.authService.Loggeduser.userid;

    const payload = {
      ApprovalDetail: {
        ...this.requestDiscountAmount,
        FK_RequestedByID: currentUserId,
        IsEdit: false,
        ApprovalType: type,
        PK_TranID: 0,
        Status: "Pending",
        RequestedDate: this.authService.getServerDate,
        RequestedTime: new Date().toTimeString().split(" ")[0],
      }
    };

    this.dashboardService.subscriptions = this.billingservice
      .insertBillingApproval(payload)
      .subscribe(
        (res: any) => {
          if (res.statusCode == 1) {
            this.requestDiscountAmount = {};
            this.approvebyName = "";
            this.closeApprovalsModal();
            this.dashboardService.openSnackBar("Request Send Successfully", "ok");
          }
        },
        (err) => {
          if (err.status === 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } else if (err.error?.statusCode === 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  // SendForDiscountApproval(event, type) {
  //   const button =
  //     event.srcElement.disabled === undefined
  //       ? event.srcElement.parentElement
  //       : event.srcElement;
  //   button.setAttribute("disabled", true);

  //   if (
  //     !this.requestDiscountAmount.FK_ApprovedByID ||
  //     this.requestDiscountAmount.FK_ApprovedByID == 0 ||
  //     this.requestDiscountAmount.FK_ApprovedByID == undefined
  //   ) {
  //     return this.dashboardService.openSnackBar(
  //       "Please Select Approval By",
  //       "ok"
  //     );
  //   } else if (!this.requestDiscountAmount.Reason) {
  //     return this.dashboardService.openSnackBar("Please Enter Reason", "ok");
  //   } else {
  //     this.requestDiscountAmount.FK_RequestedByID =
  //       this.authService.Loggeduser.userid;
  //     this.requestDiscountAmount.IsEdit = false;
  //     this.requestDiscountAmount.ApprovalType = type;
  //     this.requestDiscountAmount.FK_BillID = this.requestDiscountAmount.FK_BillID;
  //     this.requestDiscountAmount.PK_TranID = 0;
  //     this.requestDiscountAmount.Status = "Pending";
  //     this.requestDiscountAmount.RequestedDate = this.authService.getServerDate;
  //     this.requestDiscountAmount.RequestedTime = new Date()
  //       .toTimeString()
  //       .split(" ")[0];
  //     let payload = {
  //       ApprovalDetail: this.requestDiscountAmount,
  //     };

  //     this.dashboardService.subscriptions = this.billingservice.insertBillingApproval(payload).subscribe(
  //       (x) => {
  //         if (x.statusCode == 1) {
  //           this.requestDiscountAmount = {};
  //           this.approvebyName = "";
  //           this.closeApprovalsModal();

  //         }
  //       },
  //       (err) => {
  //         if (err.status == 403) {
  //           this.dashboardService.openSnackBar("You Don't have Permission", "OK");
  //         }
  //         else if (err.error.statusCode == 422) {
  //           this.dashboardService.openSnackBar(err.error.message, "OK");
  //         }
  //         else {
  //           this.dashboardService.openSnackBar("API Failed", "OK");
  //         }
  //       }
  //     );
  //   }
  // }
  // editbillingform(receiptdata: any, type: any) {

  //   if (this.billingservice.billserviceConfig.approvalSystem == true) {
  //     this.dashboardService.subscriptions = this.billingservice
  //       .getRequestStatusdata(
  //         this.authService.Loggeduser.branchid,
  //         this.authService.getServerDate,
  //         this.authService.getServerDate,
  //         type,
  //         0,
  //         receiptdata.pK_ReceiptId
  //       )
  //       .subscribe(
  //         (x: any) => {
  //           debugger
  //           if (x.length > 0) {
  //             const checkstatus = x.filter(
  //               (item) => item.status == "Pending"
  //             );
  //             const rejectestatus = x.filter(
  //               (item) => item.status == "Reject"
  //             );
  //             const checkapprovedagain = x.filter(
  //               (item) =>
  //                 item.status == "Approved" && item.requestUsed == null
  //             );
  //             if (checkstatus.length > 0) {
  //               if (type == "ReceiptModification") {
  //                 this.popupdynamicData =
  //                   "Receipt Modification Pending for Approval.";
  //               } else {
  //                 this.popupdynamicData = "Receipt Modification Pending for Approval.";
  //               }

  //               document.getElementById(
  //                 "billModificationRequestpending"
  //               ).style.display = "block";
  //             } else if (
  //               rejectestatus.length > 0 &&
  //               checkapprovedagain.length == 0
  //             ) {
  //               if (type == "ReceiptModification") {
  //                 this.popupdynamicData =
  //                   "Receipt Modification Request is Rejected.";
  //               } else {
  //                 this.popupdynamicData = "Receipt Modification Request is Rejected.";
  //               }

  //               document.getElementById(
  //                 "billModificationRequestpending"
  //               ).style.display = "block";
  //             } else {

  //               if (type == "ReceiptModification") {

  //                this.approvalmodel();

  //               }
  //             }
  //           } else {
  //             this.approvalmodel();
  //           }
  //         },
  //         (err) => {
  //           this.dashboardService.openSnackBar("API Failed", "ok");
  //         }
  //       );
  //   }

  // }
  closeBillModificationRequestPending() {
    document.getElementById("billModificationRequestpending").style.display =
      "none";
  }

  refreshdata() {
    this.ngOnInit();
  }



  setAdvanceRecipt() {

    this.getdipaymenttype();
    this.getdiposittype();
    this.getbanktype();
    this.ReciptData.FK_RegId = this.opdvisitService.patientdetails.pkRegId;
    this.ReciptData.PaymentDate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    this.ReciptData.PaymentTime = this.cuurentTime;
    this.ReciptData.CurrencyAmount = parseInt(this.currentpayable);
    this.ReciptData.AmountINR = parseInt(this.currentpayable);
    this.ReciptData.receiptNoFull = null;
    this.ReciptData.PK_ReceiptId = 0;
    this.rowClicked = -1;
    this.ReciptData.Createdby = this.authService.Loggeduser.pUserName;
    this.ReciptData.ReceiptNo = 0;
    this.ReciptData.FK_CreatedById = this.authService.Loggeduser.userid;
    this.ReciptData.FK_CancelledById = null;
    this.ReciptData.PrintCount = 0;
    this.ReciptData.IsActive = 1;
    this.ReciptData.FK_BillingCompanyId = this.authService.Loggeduser.billingcompanyid;
    this.ReciptData.FK_FinyearId = this.authService.Loggeduser.finyear;
    this.ReciptData.FK_BranchId = this.authService.Loggeduser.branchid;
    this.ReciptData.FK_DepositHeadId = 1;
    this.ReciptData.FK_CurrencyId = 1;
    this.ReciptData.ConvertRetio = 1;
    this.ReciptData.AmountTDS = 0;
    this.ReciptData.AmountDiscount = 0;
    this.ReciptData.AmountDisAllow = 0;
    this.ReciptData.AmountST = 0;
    this.ReciptData.FK_DoctorId = this.billingservice.billserviceConfig.fK_DoctorId;
    this.ReciptData.FK_PayTypeId = 1;
    this.ReciptData.ChequeNo = null;
    this.ReciptData.CardType = null;
    this.ReciptData.FK_ChqBankId = null;
    this.ReciptData.ChequeDate = null;
    this.ReciptData.FK_ChqBankId = null;
    this.ReciptData.RefBankBranch = null;
    this.ReciptData.FK_ClrBankId = null;
    this.ReciptData.IsCoPayment = 0;
    this.ReciptData.FK_DepositTypeId = 1;
    this.ReciptData.IsAdjusted = 0;
    this.ReciptData.FK_AdjustedBillId = 0;
    this.ReciptData.UserRemarks = null;
    this.ReciptData.Iscancelled = 0;
    this.ReciptData.RecptGenerateBSWise = "";
    this.ReciptData.IsAdjusted = false;

  }

  closePartialAmount() {

    document.getElementById("PartialAmountModel").style.display = "none";
  }

  openPartialAMount() {
    this.checkpartialAdjust = true;
    if (this.checkpartialAdjust == true) {
      document.getElementById("PartialAmountModel").style.display = "block";
    }

  }

  //  getPartialAmount(amount:number){
  //    if(amount <= this.ReciptData.CurrencyAmount){
  //     this.PartialAmount = amount;
  //      console.log(this.PartialAmount);
  //      this.PartialBalancedAmmount  = parseInt(this.ReciptData.CurrencyAmount) - this.PartialAmount;
  //      console.log(this.PartialBalancedAmmount);
  //    }
  //    else{
  //     this.dashboardService.openSnackBar("Amount can't be greater then current Amount", "OK");
  //    }


  //  }
  //  setpartialRecipt(){
  //    this.AdjustedBillArray =null;
  //    this.billingservice.AdjustedBillingAmount =0;
  //   this.ReciptData.AmountINR  = this.PartialBalancedAmmount ;
  //   this.ReciptData.FK_AdjustedBillId = this.BillID;

  //   this.submitAdjustedamount();
  //   document.getElementById("PartialAmountModel").style.display = "none";
  //  }


  prientReciprt(rid) {
    if (rid) {
      window.open(this.reporturl + 'Receipt.aspx?ReceiptId=' + rid + '&BranchId=' + this.authService.Loggeduser.branchid + '&BillingCompanyName=' + this.authService.Loggeduser.billingcompanyname + '&PageHeadWebReport=' + 'Y');
    }
    else {
      this.dashboardService.openSnackBar("Please Select Receipt ", "OK");
    }


  }


  failedurl(err) {
    this.dashboardService.openSnackBar("summary api url failed ", "OK");
  }

  branchmansterObj: any = {};
  getBranchDetail(id) {
    this.branchmansterObj = {};
    this.dashboardService.subscriptions = this.branchMatserService.getBrachMasterItem(id).subscribe((x: any) => {
      this.branchmansterObj = x[0];
    })
  }
  printTimeline(id) {

    let checkreporttype = this.authService.webreportConfig.filter(item => item.printOption == 'Receipt' && item.printType == 'NetramReport');
    if (checkreporttype.length > 0) {
      this.prientReciprt(id);
    } else {
      this.printTimelinedata(id);
    }

  }

  patientData: any;
  printTimelinedata(rid) {

    if (rid) {
      const recpdata = this.ReciptArray.filter(item => item.pK_ReceiptId == rid);
      if (recpdata[0]?.fK_RegId != null) {
        this.dashboardService.subscriptions = this.opdvisitService.getpatientdetailsforReciept(recpdata[0]?.fK_RegId).subscribe((data: any) => {
          this.patientData = data;
          let payload = {
            "WebReportPrintMaster": {
              "module": "Receipt",
              "printOption": "Receipt",
              "printType": "WebNetramReport",
              "PATIENTNAME": this.patientData.firstName +
                " " +
                this.patientData.lastName,
              "MRDNO": this.patientData.pkRegId,
              "Pk_RegId": this.patientData.pkRegId,
              "MobileNo": this.patientData.mobileNo,
              "PatientAddress": this.patientData.paddress,
              "PRINTDATE": this.datePipe.transform(this.authService.localDate, "dd/MM/yyyy"),
              // "VisitDate": this.datePipe.transform(this.emrservice.visitDate, "dd-MM-yyyy"),
              "PrintTime": this.convertTime12Hour(new Date()),
              "PatientAge": recpdata[0]?.age ? recpdata[0]?.age : this.patientData.ageYear,
              "PatientGender": this.patientData.sex,
              "PatientAgeAndGender": recpdata[0]?.age ? recpdata[0]?.age : this.patientData.ageYear + '|' + this.patientData.sex,
              "BILLINGCOMPANYNAME": this.authService.Loggeduser.billingcompanyname,
              "LINE1": this.branchmansterObj.line1,
              "LINE2": this.branchmansterObj.line2,
              "LINE3": this.branchmansterObj.line3,
              "LINE4": this.branchmansterObj.line4,
              "HOSPITALIMAGE": `${window.location.origin}/${this.authService.loginclientlogo}`,
              "COMPANYIMAGE": `${window.location.origin}/${this.authService.leftbottomlogosm}`,
              "CERTIFICATE1IMAGE": `${window.location.origin}/${this.authService.nabhlogo}`,
              "CERTIFICATE2COMPANYIMAGE": '',
              "AdvisedBy": recpdata[0]?.createdBy ? recpdata[0]?.createdBy : this.authService.Loggeduser.firstname,
              "DOCTORNAME": this.Doctornamedata(recpdata[0]?.fK_DoctorId),
              "RECEIPTNO": recpdata[0]?.receiptNoFull,
              "RECEIPTDATE": this.datePipe.transform(recpdata[0]?.payDate, "dd/MM/yyyy"),
              "DEPOSITETYPE": recpdata[0]?.depositType,
              "Pk_BranchId": this.authService.Loggeduser.branchid,
              "Pk_LoggedUserId": this.authService.Loggeduser.userid,
              "MOP": recpdata[0]?.payType,
              "MOPID": recpdata[0]?.chequeNo,
              "PARTYNAME": recpdata[0]?.partyName,
              "HEADNAME": this.headData(recpdata[0]?.fK_DepositHeadId),
              "AMOUNT": recpdata[0]?.amount,
              "AMOUNTINWORDS": this.converIntoWord(recpdata[0]?.amount),
              "AMOUNTDISCOUNT": recpdata[0]?.recpdata,
              "RECEIPTTIME": this.ReciptData.UserRemarks ? this.ReciptData.UserRemarks : '',
              "ReceiptArray": 'Y',
              "PatientRegistrationArray": 'Y',
              "PrintHeaderArray": 'Y',

            }

          }

          this.dashboardService.subscriptions = this.ipdService.GetWebReportPrint(payload).subscribe((x: any) => {
            if (x.length > 0) {
              let printContents, popupWin;

              printContents = x[0].printTemplate;
              popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

              popupWin.document.open();
              popupWin.document.write(`
     <html>
      
   <body onload="window.print()">${printContents}
   </body>
     </html>`
              );

              popupWin.document.close();
              if (this.patientData.emailAddress != null && this.patientData.emailAddress != undefined && this.patientData.emailAddress != "") {
                const formData = new FormData();
                formData.append('EmailCC', '');
                formData.append('SubjectCustom', "Receipt");
                formData.append('EmailType', 'CORPORATE DETAIL');
                formData.append('ToEmail', this.patientData.emailAddress);
                formData.append('MessageTemplateCustom', printContents);
                this.billingservice.sendEmail(formData).subscribe(data => {

                  this.dashboardService.openSnackBar(data.message, 'Ok');

                });
              }
            } else {
              this.dashboardService.openSnackBar("Report Template Not Set", "OK");
            }
          }, err => {
            this.dashboardService.openSnackBar("Api Failed", "OK");
          })
        })
      }
    } else {
      this.dashboardService.openSnackBar("Please Select Receipt ", "OK");
    }
  }
  timecheck: any;
  convertTime12Hour(time) {
    this.timecheck = null;
    this.timecheck = this.datePipe.transform(time, "HH:mm:ss");
    if (this.timecheck != null && this.timecheck != '') {
      let hour = (this.timecheck.split(':'))[0]
      let min = (this.timecheck.split(':'))[1]
      let part = hour > 12 ? 'PM' : 'AM';

      min = (min + '').length == 1 ? `0${min}` : min;
      hour = hour > 12 ? hour - 12 : hour;
      hour = (hour + '').length == 1 ? `0${hour}` : hour;

      return (`${hour}:${min} ${part}`)
    } else {
      return null;
    }

  }
  converIntoWord(balanceamount: number) {
    const numWords = require('num-words');
    const amountInWords = numWords(balanceamount);
    return amountInWords.toUpperCase();
  }
  headData(param) {
    if (param != null) {
      const headnamedata = this.billingservice.billService.filter(item => item.billSerieseId == param);
      if (headnamedata.length > 0) {
        return headnamedata[0].billSerieseName;

      } else {
        return null;
      }
    } else {
      return null;
    }

  }
  Doctornamedata(id) {
    return this.opdvisitService.doctors.filter(item => item.userId == id)[0]?.userName;
  }

  formattimechange(appttime: string) {
    if (appttime == null) {
    } else {
      var hr_min_sec = appttime.split(".", 2);
      var hr_min = hr_min_sec[0].split(":", 3);
      return hr_min[0] + ":" + hr_min[1];
    }
  }
  isselfrequest: boolean = false;
  AllUserControll() {

    this.AllUserCtrl = new FormControl();
    var userdatacheck = [];
    this.billingservice.GetApprovalUser('BILLING').subscribe((data) => {

      if (data.length > 1) {
        userdatacheck = data.filter(
          (item) => item.pkUserId != this.authService.Loggeduser.userid
        );
        this.isselfrequest = false;
      } else {
        userdatacheck = data;
        this.isselfrequest = true;
      }
      this.filteredAllUserArray = this.AllUserCtrl.valueChanges.pipe(
        startWith(""),
        map((cat) => userdatacheck.slice())
      );

    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  approvebyName: any = '';
  getALlUserTypeobj(e: any) {

    var val = e.option.value;
    this.approvebyName = val.userName;
    this.AllUserCtrl.setValue(val.userName);
    this.billingservice.getUsertypemenuPermission(val.fkUserTypeId, val.pkUserId).subscribe(
      (item: any) => {
        if (item.length > 0) {
          let checkbillingAllow = item.filter(
            (x) =>
              x.menuDetailName == "mnuPatientBilling" && x.webIsMenu == true
          );
          if (checkbillingAllow.length > 0) {
            this.approvebyName = val.userName;
            this.requestDiscountAmount.FK_ApprovedByID = val.pkUserId;
          } else {
            this.approvebyName = '';
            this.dashboardService.openSnackBar(
              "Billing Module Not Allowed Selecting User.",
              "ok"
            );

            this.requestDiscountAmount.FK_ApprovedByID = 0;
          }
        } else {
          this.dashboardService.openSnackBar(
            "Billing Module Not Allowed Selecting User.",
            "ok"
          );
          this.requestDiscountAmount.FK_ApprovedByID = 0;
        }
      },
      (err) => {
        this.requestDiscountAmount.FK_ApprovedByID = 0;
        this.dashboardService.openSnackBar("API Failed", "ok");
      }
    );
  }
  CheckApprovedType(event) {
    if (event.target.value == "") {
      this.requestDiscountAmount.FK_ApprovedByID = 0;
    }
  }
  approvalmodel() {
    this.closeBillModificationRequestPending();
    document.getElementById("approvalsModal").style.display = "block";
  }
  closeApprovalsModal() {
    document.getElementById("approvalsModal").style.display = "none";
  }
  getbillingRemarks(parameter) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "33vw",
      disableClose: true,
      width: "33%",

      data: {
        parametertype: parameter,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result != 0) {
        this.ReciptData.CardType = result;
      }
    });
  }
}
